module.exports = __webpack_public_path__ + "img/no0.22078c6.png";